import { useSyncExternalStore } from 'react';

import { getTimeZoneVersion, getUnusableTimeZone, subscribeActiveTimeZone } from '@/shared/format';

/**
 * How many times a live session moved the zone every date is shown in (`setActiveTimeZone`): the
 * platform changed the tenant's while the session was open and the session was refreshed. A screen
 * keyed by it is drawn again, with the new zone, instead of keeping the hours it formatted with the
 * old one.
 */
export function useTimeZoneVersion(): number {
  return useSyncExternalStore(subscribeActiveTimeZone, getTimeZoneVersion, getTimeZoneVersion);
}

/** The zone the session named and this browser could not use, or null: the screens say it instead of showing Buenos Aires hours without a word. */
export function useUnusableTimeZone(): string | null {
  return useSyncExternalStore(subscribeActiveTimeZone, getUnusableTimeZone, getUnusableTimeZone);
}
